import { AGENDA_VIEW_KEYS, DEFAULT_AGENDA_VIEW } from '@/constants/agenda'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const agendaSearchSchema = z.object({
  view: z
    .enum(AGENDA_VIEW_KEYS as [string, ...string[]])
    .optional()
    .default(DEFAULT_AGENDA_VIEW),
  date: z.string().optional(),
})

export type AgendaSearch = z.infer<typeof agendaSearchSchema>

export const Route = createFileRoute('/_authenticated/org/$orgId/agenda/')({
  validateSearch: (search) => agendaSearchSchema.parse(search),
})
